/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export default {
  command_intelligence_drawer_title: 'Command Intelligence',
  command_intelligence_drawer_resize_handle: 'Lohistage paneeli suuruse muutmiseks',
  command_intelligence_close_aria: 'Sulge assistent',
  command_intelligence_send_aria: 'Saada sõnum',
  command_intelligence_stop_aria: 'Peata vastus',
  command_intelligence_composer_input_aria: 'Sõnum Command Intelligence’ile',
  command_intelligence_drawer_more_options: 'Rohkem valikuid',
  command_intelligence_dock_position: 'Dokkimise asukoht',
  command_intelligence_dock_left: 'Vasak',
  command_intelligence_dock_right: 'Parem',
  command_intelligence_dock_top: 'Üles',
  command_intelligence_dock_bottom: 'Alla',
  command_intelligence_panel_layout: 'Paneeli paigutus',
  command_intelligence_panel_layout_overlap: 'Kattuv sisu',
  command_intelligence_panel_layout_push: 'Lükka sisu',
  command_intelligence_panel_auto_hide_overlap: 'Peida automaatselt väljaspool klõpsates',
  command_intelligence_session_reset: 'Lähtesta vestlus',
  command_intelligence_try_one_of_these: 'Proovige ühte neist',
  command_intelligence_attach_hint: 'Lisage kontekstielemente, et hakata küsimusi esitama.',
  command_intelligence_welcome_subhead: 'Esitage küsimus alustamiseks.',
  command_intelligence_attach_modal_title: 'Lisa kontekst',
  command_intelligence_attach_modal_subtitle: 'Valige selle vaate elementidest. Juba lisatud elemendid on hallid.',
  command_intelligence_attach_modal_search_placeholder: 'Otsi…',
  command_intelligence_attach_modal_pool:
    '{count, plural, one {# element saadaval} other {# elementi saadaval}} · valitud {selected}',
  command_intelligence_attach_modal_empty: 'Pole midagi lisada',
  command_intelligence_attach_modal_no_results: 'Ükski element ei vasta otsingule',
  command_intelligence_context_bar_attached_section: 'Lisatud ({count})',
  command_intelligence_context_bar_clear_attached: 'Tühjenda',
  command_intelligence_context_bar_add: 'Lisa kontekst',
  command_intelligence_placeholder_ready: 'Esitage küsimus…',
  command_intelligence_placeholder_attach: 'Lisage kontekst küsimuse esitamiseks…',
  command_intelligence_composer_submit_hint: 'Enter saatmiseks · Shift+Enter uue rea jaoks',
  command_intelligence_composer_stop_hint: 'Peata · järgmise sõnumi mustand ootamise ajal',
  command_intelligence_response_stopped: 'Vastus peatatud',
  command_intelligence_generation_in_progress: 'Teie küsimuse töötlemine',
  command_intelligence_generation_trace_title: 'Tehtud sammud',
  command_intelligence_generation_trace_toggle: 'Näita samme',
  command_intelligence_generation_trace_summary: '{completed}/{total} sammu lõpetatud',
  command_intelligence_generation_trace_summary_generic: 'Genereerimise sammud',
  command_intelligence_generation_tool_count: '{count, plural, one {# tööriist} other {# tööriista}}',
  command_intelligence_generation_turn_label: 'Käik {turn}/{total}',
  command_intelligence_generation_turn_completed: 'Käik {turn}/{total} lõpetatud',
  command_intelligence_generation_turn_completed_elapsed: 'Käik {turn}/{total} lõpetatud ({seconds}s möödunud)',
  command_intelligence_generation_turn_completed_with_tools: 'Käik {turn}/{total} lõpetatud – kasutas {tools}',
  command_intelligence_generation_tools_used: 'Kasutas {tools}',
  command_intelligence_reasoning_thinking: 'Mõtlen…',
  command_intelligence_reasoning_thought_for_seconds: 'Mõtles {seconds} sekundit',
  command_intelligence_reasoning_waiting: 'Teie küsimuse töötlemine…',
  command_intelligence_attach_modal_done: 'Valmis',
  command_intelligence_attach_modal_attached_badge: 'lisatud',
  command_intelligence_attach_modal_attach: 'Lisa',
  command_intelligence_attach_modal_attach_count: 'Lisa ({count})',
  command_intelligence_attach_modal_close_aria: 'Sulge valija',
  command_intelligence_session_limit_context: 'Konteksti limiit saavutatud. Jätkamiseks lähtestage vestlus.',
  command_intelligence_session_limit_prompt: 'Sõnumite limiit saavutatud. Jätkamiseks lähtestage vestlus.',
  command_intelligence_suggested_followups: 'Soovitatud järelküsimused',
  command_intelligence_credit_warning_line: '{pct}% {scope} igakuistest tehisintellekti krediitidest kasutatud',
  command_intelligence_tooltip_prompts: '{count}/{max} sõnumit ({pct}%)',
  command_intelligence_tooltip_context: '{used}/{max} konteksti märki ({pct}%)',
  command_intelligence_tooltip_context_idle: 'Konteksti kasutus ilmub pärast esimest vastust',
  command_intelligence_credits_loading: 'Krediitide laadimine…',
  command_intelligence_credits_unavailable: 'Krediidid pole saadaval',
  command_intelligence_credits_tooltip: 'Igakuised tehisintellekti krediidid {monthKey}',
  command_intelligence_credits_tooltip_short: 'Igakuised tehisintellekti krediidid',
  command_intelligence_credits_scope_profile: 'Profiil',
  command_intelligence_credits_scope_entity: 'Üksus',
  command_intelligence_credits_used_of_cap: '{used}/{cap} krediiti',
  command_intelligence_credits_used_no_cap: '{used} krediiti kasutatud',
  command_intelligence_credits_monthly_title: 'Igakuised tehisintellekti krediidid',
  command_intelligence_compare_aria: 'Võrdle agente',
  command_intelligence_compare_tooltip: 'Käivita sama küsimus mitme agendi profiili vastu',
  command_intelligence_compare_cancelled: 'Võrdlus tühistatud',
  command_intelligence_compare_branch_failed: 'Võrdluse haru ebaõnnestus',
  command_intelligence_compare_title: 'Agentide võrdlus',
  command_intelligence_compare_stats: '{durationMs} ms · {model} · {inTok} sisse / {outTok} välja · {agentRef}',
  command_intelligence_compare_error: '{message}',
  command_intelligence_profile_agent: '{agentRef}',
  command_intelligence_feedback_good_response: 'Hea vastus',
  command_intelligence_feedback_bad_response: 'Halb vastus',
  command_intelligence_feedback_dialog_title: 'Anna tagasisidet',
  command_intelligence_feedback_dialog_body:
    'Aidake meil paremaks saada, andes tagasisidet selle vastuse kohta. Teie tagasiside saadetakse meie operatiivmeeskonnale.',
  command_intelligence_feedback_response_label: 'Vastus',
  command_intelligence_feedback_input_label: 'Teie tagasiside (valikuline)',
  command_intelligence_feedback_input_placeholder: 'Mis selles vastuses oli vale või ebaabistav?',
  command_intelligence_feedback_submit: 'Saada tagasiside',
  command_intelligence_feedback_submit_error: 'Tagasiside saatmine ebaõnnestus. Proovige uuesti.',
  command_intelligence_feedback_question_understanding: 'Kas agent mõistis, mida soovisite?',
  command_intelligence_feedback_question_readability: 'Kas vastus oli lihtne lugeda ja kasutada?',
  command_intelligence_feedback_section_understanding: 'Mõistmine',
  command_intelligence_feedback_section_readability: 'Loetavus',
  command_intelligence_feedback_choice_none: 'Puudub',
  command_intelligence_feedback_choice_misunderstood_task: 'Saanud ülesande valesti aru',
  command_intelligence_feedback_choice_ignored_constraint: 'Ignoreeris piirangut',
  command_intelligence_feedback_choice_wrong_scope: 'Vale ulatus',
  command_intelligence_feedback_choice_visually_hard_to_read: 'Visuaalselt raske lugeda',
  command_intelligence_feedback_choice_wrote_too_much: 'Kirjutas liiga palju',
  command_intelligence_feedback_choice_explanation_not_trustworthy: 'Selgitus pole usaldusväärne',
  command_intelligence_copy_aria: 'Kopeeri lõikelauale',
  command_intelligence_error_missing_invoke_permission:
    'Teil pole luba kasutada Command Intelligence’i selle agendi jaoks. Paluge administraatoril anda vajalikud Intelligence’i õigused (nt analyst).',
  command_intelligence_access_denied_title: 'Juurdepääs nõutav',
  command_intelligence_error_session_expired: 'Teie seanss on aegunud. Värskendage lehte ja logige uuesti sisse.',
};
